/**
 * Prepare list of current and passed drawings for the drawing selector
 * @param  {Object} drawings parameter to the drawings
 * @return {Object} list of select options
 */
export const selectValuesFromDrawings = drawings => {
    drawings = drawings
        .filter(drawing => parseInt(drawing.category, 10) == 1)
        .filter(drawing => drawing.draw_status !== 'future');

    let options = [];

    for (const [, value] of Object.entries(drawings)) {
        const drawLabel =
            value.draw_number === 11
                ? 'FINAL DRAW'
                : `DRAW ${value.draw_number}`;
        options.push({
            label: drawLabel,
            value: parseInt(value.draw_number, 10) ?? 0,
        });
    }

    return options;
};
